export default "__VITE_ASSET__CsWe7mUU__"